<div class="info">
  <tr-icon class="time-icon" [icon]="icon.time" [size]="size.belowAverage" [color]="iconColor"></tr-icon>

  <ng-container *ngIf="type === floorPlanPartyType.booked">
    <p class="time {{ colorClass }}">Scheduled: {{ quotedTime | momentDate: 'LT': timezone }} (in {{ quotedTime | momentFromNow: true: timezone }})</p>
  </ng-container>

  <ng-container *ngIf="type === floorPlanPartyType.overdue">
    <p class="time {{ colorClass }}">Scheduled: {{ quotedTime | momentDate: 'LT': timezone }} ({{ quotedTime | momentFromNow: false: timezone }})</p>
  </ng-container>

  <ng-container *ngIf="type === floorPlanPartyType.waiting">
    <p class="time {{ colorClass }}">Quoted: {{ quotedTime | momentFromNow: false: timezone }} (waiting {{ checkInTime | momentFromNow: true: timezone }})</p>
  </ng-container>

  <ng-container *ngIf="type === floorPlanPartyType.checkedIn">
    <p class="time {{ colorClass }}">Checked in: {{ checkInTime | momentDate:'LT': timezone }} (waiting {{ checkInTime | momentFromNow: true: timezone }})</p>
    <p class="time {{ colorClass }}">Scheduled: {{ quotedTime | momentDate: 'LT': timezone }} ({{ quotedTime | momentFromNow: false: timezone }})</p>
  </ng-container>

  <ng-container *ngIf="type === floorPlanPartyType.serving">
    <p class="time {{ colorClass }}">Served: {{ seatedTime | momentDate: 'LT': timezone }} ({{ seatedTime | momentFromNow: false: timezone }})</p>
    <p class="time {{ colorClass }}">Ending: {{ quotedTime + duration | momentDate: 'LT': timezone }} ({{ quotedTime + duration | momentFromNow: false: timezone }})</p>
  </ng-container>
</div>
